/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryTemplateType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryTemplateType");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryTemplateType.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryTemplateType>): AutomationTemplateQueryTemplateType {
        let obj = Object.assign(new AutomationTemplateQueryTemplateType(), model);
        AutomationTemplateQueryTemplateType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryTemplateType>): AutomationTemplateQueryTemplateType {
        if (!model) return null;
        return AutomationTemplateQueryTemplateType.newInstance(<AutomationTemplateQueryTemplateType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryTemplateType) {
        if (!obj) return;

        models.AutomationTemplateQueryTemplateType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryTemplateType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryTemplateType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template types to include
     */
    template_type: Array<models.TemplateType>;

}
